// extracted by mini-css-extract-plugin
export default {"departments":"iJ-z","departmentHeading":"jJ-z","departmentSection":"kJ-z","departmentName":"lJ-z","departmentLink":"mJ-z","expandIcon":"nJ-z"};